module.exports = __webpack_public_path__ + "img/banker-purple_320.22e14ba2.png";